<template>
	<div class="row">
		<slot></slot>
	</div>
</template>

<script setup lang="ts">

</script>

<style lang="scss" >

</style>